import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<this.BaseAntecedentsFields {{!-- @glint-expect-error --}} @form={{@form}} {{!-- @glint-expect-error --}} @patient={{@patient}} />", {
  moduleName: "core/components/medical-history/onco/cervix-cancer/antecedents-fields/index.hbs"
});